import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
// import { Button } from "react-bootstrap";
import { SiMicrosoftteams } from "react-icons/si";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import SearchIcon from "@mui/icons-material/Search";
import EmailIcon from "@mui/icons-material/Email";
import PhonelinkRingIcon from "@mui/icons-material/PhonelinkRing";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import axios from "axios";
import { BaseUrl } from "../../../container/BaseUrl/BaseUrl";
import { errorhandelApi } from "../../../ApiCall/ErrorHandelApi";
import { connect } from "react-redux";
import "./userdetails.css";
import {
  setselectedusername,
  setselectedemail,
  setselectedmobile,
  setselectedwhatsapp,
  setselectedfacebook,
  setselectedtwitter,
  setselectedteams,
  setselectedcompany,
  setselectedadress,
  setselectedid,
  setChatRefresh,
  setCustomerDetailsShow,
  setAcceptChatActive,
  setSelectedvip,
  setcontactlist,
  setSelectedColor,
} from "../../../redux/actions/actions";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Badge } from "react-bootstrap";
import CustomerDetailSearchNew from "./Customer-Detail-Search/Customer-Detail-Search-New";

const mapStateToProps = (state) => {
  const { data } = state;
  return {
    selectedusername: data.selectedusername,
    selectedemail: data.selectedemail,
    selectedmobile: data.selectedmobile,
    selectedwhatsapp: data.selectedwhatsapp,
    selectedfacebook: data.selectedfacebook,
    selectedtwitter: data.selectedtwitter,
    selectedteams: data.selectedteams,
    selectedcompany: data.selectedcompany,
    selectedaddress: data.selectedaddress,
    selectedid: data.selectedid,
    externalChatData: data.externalChatData,
    chat: state.data.chat,
    selectedisvip: data.selectedisvip,
    contactList: data.contactList,
    usercolor: data.usercolor,
  };
};

const UserDetails = (props) => {
  const [editUserModal, setEditUserModal] = useState(false);
  const [editemail, seteditemail] = useState(props.selectedemail);
  const [editusername, seteditusername] = useState(props.selectedusername);
  const [editmobile, seteditmobile] = useState(props.selectedmobile);
  const [editwhatsapp, seteditwhatsapp] = useState(props.selectedwhatsapp);
  const [editfacebook, seteditfacebook] = useState(props.selectedfacebook);
  const [edittwitter, setedittwitter] = useState(props.selectedtwitter);
  const [editteams, seteditteams] = useState(props.selectedteams);
  const [editcompany, seteditcompany] = useState(props.selectedcompany);
  const [editaddress, seteditaddress] = useState(props.selectedaddress);
  const [editisvip, setEditisvip] = useState(props.selectedisvip);
  const [CustomerDetailSearch, setCustomerDetailSearch] = useState(false);
  const [validateemail, setValidateemail] = useState(false);
  const [mailvalidity, setMailvalidity] = useState(false);

  const [Numbercopyed, setNumbercopyed] = useState("Copy");
  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));

  const updateEditvalueModel = () => {
    setEditUserModal(!editUserModal);
  };

  const getDataOnload = async () => {
    try {
      const datas = JSON.parse(localStorage.getItem("tokenAgent"));
      await axios
        .post(
          `${BaseUrl}/users/allUsers?agent_id=${datas.id}`,
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.length > 0) {
            props.setcontactlist(res.data);
            props.setExternalChatData(res.data);
          } else {
            console.log("error");
          }
        })
        .catch((err) => {});
    } catch (err) {}
  };

  const updateEditvalue = async () => {
    const tokenAgent = JSON.parse(localStorage.getItem("tokenAgent"));
    const agent_ID = tokenAgent.id;
    const access_token = localStorage.getItem("access_token");
    let body = {
      username: editusername,
      email: editemail == "Empty" ? "" : editemail,
      phonenumber: editmobile == "Empty" ? "" : editmobile,
      whatsappnumber: editwhatsapp == "Empty" ? "" : editwhatsapp,
      facebookId: editfacebook == "Empty" ? "" : editfacebook,
      twitterId: edittwitter == "Empty" ? "" : edittwitter,
      teamsId: editteams == "Empty" ? "" : editteams,
      address: editaddress == "Empty" ? "" : editaddress,
      company: editcompany == "Empty" ? "" : editcompany,
      id: props.selectedid,
      isvip: editisvip,
      agent_id: agent_ID,
      chat_session_id: props.externalChatData.chat_session_id
        ? props.externalChatData.chat_session_id
        : "",
    };

    axios
      .post(BaseUrl + "/users/updateClient", body, {
        headers: {
          Authorization: "Bearer " + access_token,
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        updateEditvalueModel();
        // props.setChatRefresh(true);
        getDataOnload();
        // props.setAcceptChatActive(true);
        props.setselectedemail(editemail);
        props.setselectedusername(editusername);
        props.setselectedmobile(editmobile);
        props.setselectedwhatsapp(editwhatsapp);
        props.setselectedfacebook(editfacebook);
        props.setselectedtwitter(edittwitter);
        props.setselectedteams(editteams);
        props.setselectedcompany(editcompany);
        props.setselectedadress(editaddress);
        props.setSelectedvip(editisvip);
        // getDataOnload()
        // props.setChatRefresh(true);
        toast.success("Client details Updated Successfully", {
          position: "top-right",
          autoClose: 500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
      })

      .catch((error) => {
        errorhandelApi(error, "/users/updateClient");
      });
  };

  useEffect(() => {
    seteditemail(props.selectedemail);
    seteditusername(props.selectedusername);
    seteditmobile(props.selectedmobile);
    seteditwhatsapp(props.selectedwhatsapp);
    seteditfacebook(props.selectedfacebook);
    setedittwitter(props.selectedtwitter);
    seteditteams(props.selectedteams);
    seteditcompany(props.selectedcompany);
    seteditaddress(props.selectedaddress);
    setEditisvip(props.selectedisvip);
  }, [props.externalChatData.id]);

  const CrmScreenpopupApi = async () => {
    let body;
    if (
      props.chat.channel == "voice" &&
      (localStorage.getItem("type") === "sales" ||
        localStorage.getItem("type") === "service")
    ) {
      body = {
        phonenumber: props.chat.phonenumber,
        skillset: props.chat.skillset,
        channel: props.chat.channel,
        type: localStorage.getItem("type"),
        reg_no: localStorage.getItem("Contactreg_no"),
        contact_id: localStorage.getItem("ContactVoiceId"),
      };
    } else {
      body = {
        phonenumber: props.chat.phonenumber,
        skillset: props.chat.skillset,
        channel: props.chat.channel,
        direction: props.chat.direction == "Inbound" ? "INBOUND" : "OUTBOUND",
      };
    }
    await axios
      .post(BaseUrl + "/ticket/crmscreenpop", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        window.open(res.data.data);
        toast.success("screen pop url generated", {
          position: "top-right",
          autoClose: 500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
      })
      .catch((error) => {
        console.log("error", error);
        toast.warning("screen pop url not generated", {
          position: "top-right",
          autoClose: 500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const handleOpenCrmUrl = () => {
    const randomNumber =
      Math.floor(Math.random() * (10000000 - 9999999 + 1)) + 9999999;
    // const url = `https://cms.inaipiapp.com/helpdesk/screenpopup?number=${props.chat.phonenumber}&type=${props.chat.channel}&direction=incoming&callid=${randomNumber}`;
    const url = `https://inaipi.ae/v2/screenpopup?number=${props.chat.phonenumber}&skillset=${props.chat.skillset}&callid=${randomNumber}&survey_opt=1&type=${props.chat.channel}&direction=INBOUND`;
    window.open(url, "_blank");
  };

  const smallButtonEditStyle = {
    fontSize: "10px",
  };
  const smallButtonEditIconStyle = {
    fontSize: "15px",
    cursor: "pointer",
  };

  const smallButtonEditStyleEmail = {
    fontSize: "13px",
  };

  const smallButtonEditStyleEmailuser = {
    fontSize: "15px",
  };

  return (
    <>
      <div class="col-md-12 ">
        <div class="card profile-header ">
          <div class="body" style={{ height: "21vh" }}>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-12">
                <div
                  className="col-2 me-2 photo position-relative"
                  style={{
                    background: "#E1F2FB",
                    width: "80px",
                    height: "80px",
                  }}
                >
                  <p
                    className="chat_name my-auto h-100"
                    style={{
                      color: "#7e7272",
                      textAlign: "center",
                      fontSize: "16px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <b
                      className="h-100 my-auto"
                      style={{
                        color: "gray",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "21px",
                      }}
                    >
                      {props.selectedusername
                        ? props.selectedusername.slice(0, 2).toUpperCase()
                        : ""}
                    </b>
                  </p>
                  <div className="d-flex justify-content-center  my-2">
                    <BootstrapTooltip title={"Edit"} arrow placement="top">
                      <BorderColorIcon
                        style={smallButtonEditIconStyle}
                        className="mx-1"
                        onClick={() => {
                          updateEditvalueModel();
                        }}
                      />
                    </BootstrapTooltip>

                    <BootstrapTooltip
                      title={"Customer Search"}
                      arrow
                      placement="top"
                    >
                      <SearchIcon
                        className="mx-1"
                        style={smallButtonEditIconStyle}
                        onClick={() => {
                          setCustomerDetailSearch(true);
                        }}
                      />
                    </BootstrapTooltip>

                    {/* {JSON.parse(localStorage.getItem("permission")).map(
                      (module) => {
                        if (module.moduleName === "Crm") {
                          const crmScreen = module.screen.find(
                            (item) =>
                              item.screenId === "CRM" && item.read && item.write
                          );

                          if (crmScreen) {
                            return ( */}
                    <BootstrapTooltip title={"CRM"} arrow placement="top">
                      <ContactPhoneIcon
                        className="mx-1"
                        style={smallButtonEditIconStyle}
                        onClick={() => {
                          CrmScreenpopupApi();
                        }}
                        s
                      />
                    </BootstrapTooltip>
                    {/* );
                          } else {
                            return null;
                          }
                        }
                        return null;
                      }
                    )} */}
                  </div>
                </div>
              </div>
              <div class="col-lg-8 col-md-8 col-12">
                <div className="d-flex">
                  <div>
                    <AccountCircleIcon
                      className="d-flex justify-content-center align-items-center mt-1"
                      style={smallButtonEditStyleEmailuser}
                    />
                  </div>
                  <div>
                    <b class="mt-0 m-b-0 mx-1">
                      {props.selectedusername === "" ||
                      props.selectedusername === "Empty"
                        ? ""
                        : props.selectedusername}
                    </b>
                  </div>
                </div>

                {props.selectedisvip ? (
                  <span
                    class="badge badge-pill bg-primary "
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "0px",
                      margin: "1px",
                    }}
                  >
                    VIP
                  </span>
                ) : (
                  <span
                    class="badge badge-pill bg-primary"
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "0px",
                      margin: "1px",
                    }}
                  >
                    Normal
                  </span>
                )}

                {/* <div className="" style={{position:'absolute',top:'0px',right:'0px',padding:'0px',margin:'0px'}}>
                <span class="badge badge-pill badge-warning">VIP</span>
                </div> */}
                <div className="w-100 d-flex">
                  <span className="">
                    <EmailIcon style={smallButtonEditStyleEmail} />
                  </span>
                  <span
                    className="mx-1 text-truncate w-100"
                    style={{ fontSize: "12px" }}
                  >
                    {props.selectedemail === "" ||
                    props.selectedemail === "Empty"
                      ? ""
                      : props.selectedemail}
                  </span>
                </div>

                {props.selectedmobile ? (
                  <div className="w-100 d-flex">
                    <span className="">
                      <PhonelinkRingIcon style={smallButtonEditStyleEmail} />
                    </span>
                    <span className="mx-1 text-truncate">
                      <BootstrapTooltip
                        title={Numbercopyed}
                        arrow
                        placement="right"
                      >
                        <p
                          className="w-100 text-break"
                          onClick={() => {
                            navigator.clipboard.writeText(props.selectedmobile);
                            setNumbercopyed("Copied");
                            setTimeout(() => {
                              setNumbercopyed("Copy");
                            }, 3000);
                          }}
                          style={{ cursor: "pointer", fontSize: "12px" }}
                        >
                          {" "}
                          {props.selectedmobile === "" ||
                          props.selectedmobile === "Empty"
                            ? " "
                            : props.selectedmobile}
                        </p>
                      </BootstrapTooltip>
                    </span>
                  </div>
                ) : (
                  ""
                )}

                <div
                  className="position-absolute p-2"
                  style={{ bottom: "0", right: "12px" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {editUserModal && (
        <Draggable handle=".handle">
          <div
            className="card"
            style={{
              position: "absolute",
              width: "47%",
              zIndex: "999",
              backgroundColor: "white",
              borderRadius: "5px",
              boxShadow: "2px 2px 20px grey",
              top: "50px",
              right: "300px",
            }}
          >
            <div
              className="card-header handle"
              style={{ backgroundColor: "#0b3363" }}
            >
              <h4
                style={{
                  fontSize: "16px",
                  color: "white",
                  fontFamily: "monospace",
                }}
              >
                <strong>EDIT USER</strong>
              </h4>
              <AiOutlineCloseCircle
                id="close_edituser"
                onClick={() => {
                  setEditUserModal(false);
                }}
                size="20px"
                style={{
                  float: "right",
                  marginTop: "-25px",
                  color: "white",
                  cursor: "pointer",
                }}
              />
            </div>

            <div className="card-body">
              <div className="row g-2">
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      value={editusername}
                      onChange={(e) => seteditusername(e.target.value)}
                    />
                    <label for="floatingInputGrid">Name</label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="email"
                      className="form-control"
                      id="floatingInputGrid"
                      value={editemail === "Empty" ? "" : editemail}
                      onChange={(e) => seteditemail(e.target.value)}
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    />
                    <label for="floatingInputGrid">Email address</label>
                  </div>
                  {validateemail ? (
                    <span
                      className="text-danger fw-bold "
                      style={{ fontSize: "10px" }}
                    >
                      Fill The Email Field*
                    </span>
                  ) : (
                    ""
                  )}
                  {mailvalidity ? (
                    <span
                      className="text-danger fw-bold "
                      style={{ fontSize: "10px" }}
                    >
                      Provide a Valid Email*
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      value={editmobile === "Empty" ? "" : editmobile}
                      onChange={(e) =>
                        seteditmobile(e.target.value.replace(/[^\d]/, ""))
                      }
                    />
                    <label for="floatingInputGrid">Phone</label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      value={editwhatsapp === "Empty" ? "" : editwhatsapp}
                      onChange={(e) =>
                        seteditwhatsapp(e.target.value.replace(/[^\d]/, ""))
                      }
                    />
                    <label for="floatingInputGrid">Whatsapp</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      value={editcompany === "Empty" ? "" : editcompany}
                      onChange={(e) => seteditcompany(e.target.value)}
                    />
                    <label for="floatingInputGrid">Company</label>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      value={editaddress === "Empty" ? "" : editaddress}
                      onChange={(e) => seteditaddress(e.target.value)}
                    />
                    <label for="floatingInputGrid">Address</label>
                  </div>
                </div>

                <div className="col-md-12">
                  <div class="custom-control custom-checkbox my-1">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      checked={editisvip}
                      id="customCheck1"
                      onChange={(e) => setEditisvip(e.target.checked)}
                    />
                    <label class="custom-control-label mx-2" for="customCheck1">
                      Is VIP
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <button
                  style={{ fontFamily: "monospace" }}
                  id="update-btn"
                  className="btn btn-primary btn-sm float-end mt-3"
                  onClick={() => {
                    if (editemail.length <= 0) {
                      setValidateemail(true);
                      setMailvalidity(false);
                    } else if (!editemail.includes("@")) {
                      setMailvalidity(true);
                      setValidateemail(false);
                    } else {
                      updateEditvalue();
                    }
                  }}
                >
                  UPDATE
                </button>
              </div>
            </div>
          </div>
        </Draggable>
      )}

      {CustomerDetailSearch && (
        <CustomerDetailSearchNew
          OpenDialog={CustomerDetailSearch}
          handleClose={() => {
            setCustomerDetailSearch(false);
          }}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, {
  setselectedusername,
  setselectedemail,
  setselectedmobile,
  setselectedwhatsapp,
  setselectedfacebook,
  setselectedtwitter,
  setselectedteams,
  setselectedcompany,
  setselectedadress,
  setselectedid,
  setChatRefresh,
  setCustomerDetailsShow,
  setAcceptChatActive,
  setSelectedvip,
  setcontactlist,
  setSelectedColor,
})(UserDetails);
